import { render } from "./PrivacyView.vue?vue&type=template&id=6336519a&scoped=true"
const script = {}

import "./PrivacyView.vue?vue&type=style&index=0&id=6336519a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6336519a"]])

export default __exports__